// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikSelect } from "src/components/Forms/Select";
import { ages } from "src/constants/account";

interface Props {}

const Ages: React.FC<Props> = () => {
  return (
    <Field label="Ages:" mb={26}>
      <FormikSelect
        name="age"
        size="middle"
        placeholder="Select..."
        data={ages}
        local
        borderRadius={2}
        borderColor="grey5"
      />
    </Field>
  );
};

export default Ages;
